import { FC } from "react";

import { IconProps } from "./IconProps";

export const Spinner: FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
}) => {
  return (
    <svg
      className={`spinner ${className}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="spinner-circle"
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="31.415 31.415"
        transform="rotate(-90 12 12)"
      />
    </svg>
  );
};
